import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',//去掉#号
    routes: [
        {
            path: '/',
            name: 'Index',
            component: resolve => require(['../views/index.vue'],resolve),
            meta: {title: 'Elichain-首页'}
        },
        {
            path: '/ecosystem',
            name: 'Ecosystem',
            component: resolve => require(['../views/ecosystem.vue'],resolve),
            meta: {title: '慕鹿生态系统'}
        },
        {
            path: '/about/elichain',
            name: 'Elichain',
            component: resolve => require(['../views/about/elichain.vue'],resolve),
            meta: {title: 'Elichain'}
        },
        {
            path: '/user_agreement_life',
            name: 'user_agreement_life',
            component: resolve => require(['../views/protocol/user_agreement_life.vue'],resolve),
            meta: {title: '用户协议'}
        },
        {
            path: '/privacy_policy_life',
            name: 'privacy_policy_life',
            component: resolve => require(['../views/protocol/privacy_policy_life.vue'],resolve),
            meta: {title: '隐私政策'}
        },
        {
            path: '/user_agreement',
            name: 'user_agreement',
            component: resolve => require(['../views/protocol/user_agreement.vue'],resolve),
            meta: {title: '用户协议'}
        },
        {
            path: '/privacy_policy',
            name: 'privacy_policy',
            component: resolve => require(['../views/protocol/privacy_policy.vue'],resolve),
            meta: {title: '隐私政策'}
        },
        {
            path: '/activeCheck/:acid',
            name: 'ActiveCheck',
            component: resolve => require(['../views/check/activeCheck'],resolve),
            meta: {title: 'Elichain-活动签到'}
        },
        // {
        //     path: '/404',
        //     name: 'NotFound',
        //     component: resolve => require(['../views/404.vue'],resolve)
        // },
        { path: '*', redirect: '/', hidden: true }
    ]
})
